import { AsanSignActions, AsanSignActionTypes, AsanSignState } from './types'

const initialState: AsanSignState = {
  status: 'idle',
  error: null,
  loading: false,
  data: null,
}

export const AsanSignReducer = (
  state = initialState,
  action: AsanSignActions
): AsanSignState => {
  switch (action.type) {
    case AsanSignActionTypes.FETCH_ASAN_SIGN_REQUEST:
      return {
        ...state,
        status: 'loading',
        loading: true,
      }
    case AsanSignActionTypes.FETCH_ASAN_SIGN_SUCCESS:
      return {
        ...state,
        status: 'success',
        loading: false,
        data: action.payload,
      }
    case AsanSignActionTypes.FETCH_ASAN_SIGN_FAILED:
      return {
        ...state,
        status: 'failed',
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}
